import { render } from "./gameShop.vue?vue&type=template&id=78148656&scoped=true"
import script from "./gameShop.vue?vue&type=script&lang=js"
export * from "./gameShop.vue?vue&type=script&lang=js"

import "./gameShop.vue?vue&type=style&index=0&id=78148656&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78148656"]])

export default __exports__